// Mock / seed content clearly separated from production data.
// Replace social-proof placeholders with verified data only.

export const EXAMS = [
  { id: "jee", name: "JEE", status: "live" },
  { id: "neet", name: "NEET", status: "live" },
  { id: "ssc", name: "SSC", status: "live" },
  { id: "banking", name: "Banking", status: "live" },
  { id: "railway", name: "Railway", status: "live" },
  { id: "govt", name: "Govt Exams", status: "live" },
  { id: "gate", name: "GATE", status: "live" },
  { id: "cat", name: "CAT", status: "live" },
];

export const PROBLEMS = [
  { title: "TOO MUCH CONTENT", body: "Thousands of resources. No clear priority.", icon: "Layers" },
  { title: "GENERIC TIMETABLES", body: "The same plan cannot work for every student.", icon: "CalendarX" },
  { title: "REPEATED MISTAKES", body: "Students often repeat the same mistakes without understanding why.", icon: "RotateCcw" },
  { title: "NO CLEAR TRAJECTORY", body: "They don't know whether today's work is moving them toward their target.", icon: "TrendingDown" },
];

export const WITHOUT = [
  "What should I study today?",
  "Which chapter should I revise?",
  "Why did my score drop?",
  "Am I actually improving?",
  "Should I watch another lecture?",
  "Why do I keep making this mistake?",
];

export const WITH = [
  "Here is today's highest-impact task.",
  "Here is why you're doing it.",
  "Here are the concepts costing you marks.",
  "Here is your current trajectory.",
  "Here are the mistakes you need to fix.",
  "Here is what tomorrow should look like.",
];

export const STEPS = [
  { n: "01", title: "DIAGNOSE", body: "Understand your actual preparation.", icon: "Stethoscope" },
  { n: "02", title: "IDENTIFY", body: "Find the concepts and behaviours costing you marks.", icon: "Search" },
  { n: "03", title: "PRIORITIZE", body: "Determine what will have the highest potential impact.", icon: "ListOrdered" },
  { n: "04", title: "PLAN", body: "Build your daily preparation strategy.", icon: "CalendarCheck" },
  { n: "05", title: "PRACTICE", body: "Give you targeted questions based on your weaknesses.", icon: "Target" },
  { n: "06", title: "ADAPT", body: "Automatically adjust your plan based on your performance.", icon: "RefreshCw" },
];

export const TODAY_PLAN = [
  { n: "01", topic: "Rotation", time: "45 min", impact: "HIGH IMPACT" },
  { n: "02", topic: "Coordinate Geometry", time: "50 min", impact: "HIGH IMPACT" },
  { n: "03", topic: "Organic Chemistry", time: "35 min", impact: "MEDIUM" },
  { n: "04", topic: "Mistake Revision", time: "25 min", impact: "" },
];

export const COACH_DEMO = [
  { role: "user", text: "I only have 2 hours today." },
  { role: "ai", text: "Don't try to cover everything. Based on your recent performance, use 50 minutes for Rotation, 35 minutes for Coordinate Geometry and 35 minutes reviewing recurring Chemistry mistakes." },
  { role: "user", text: "Can I skip Rotation?" },
  { role: "ai", text: "You can, but you've lost marks in this topic across your last three mocks. I'd reduce today's session to 25 minutes rather than remove it completely." },
];

export const MISTAKES = [
  { title: "Torque Direction", count: 3 },
  { title: "Sign Convention", count: 2 },
  { title: "Organic Reaction Mechanism", count: 4 },
];

export const TRAJECTORY = [
  { name: "Mock 1", score: 121 },
  { name: "Mock 2", score: 132 },
  { name: "Mock 3", score: 142 },
  { name: "Mock 4", score: 151 },
  { name: "Target", score: 180 },
];

export const PERF_METRICS = [
  { label: "Accuracy", value: 72, suffix: "%" },
  { label: "Speed", value: 64, suffix: "%" },
  { label: "Mastery", value: 58, suffix: "%" },
  { label: "Consistency", value: 81, suffix: "%" },
];

export const RADAR_DATA = [
  { topic: "Mechanics", you: 62, target: 90 },
  { topic: "Calculus", you: 74, target: 92 },
  { topic: "Organic", you: 48, target: 85 },
  { topic: "Algebra", you: 81, target: 90 },
  { topic: "Modern Phy", you: 66, target: 88 },
  { topic: "Coordinate", you: 43, target: 88 },
];

export const PERSONAS = [
  { title: "THE SELF-STUDIER", quote: "I know what I want. I need a system.", icon: "User" },
  { title: "THE COACHING STUDENT", quote: "I already have classes. I need personalization.", icon: "Users" },
  { title: "THE REPEATER", quote: "I've studied before. I need to know exactly what went wrong.", icon: "History" },
  { title: "THE GOVERNMENT-EXAM ASPIRANT", quote: "I need consistency and accountability.", icon: "Landmark" },
];

export const VALUE_COSTS = [
  "Random study", "Repeated mistakes", "Unnecessary lectures",
  "Poor revision", "Unanalyzed mocks", "Lost time",
];

export const FAQS = [
  { q: "What exactly is sarkarijobai?", a: "sarkarijobai is an AI exam success platform. It analyses your preparation — your scores, mistakes, weak topics and available study time — and turns that into a personalised daily preparation strategy for your target exam." },
  { q: "Is sarkarijobai another coaching app?", a: "No. sarkarijobai is an AI preparation and execution layer, not simply another content library. It sits on top of whatever resources you already use and tells you what deserves your time right now." },
  { q: "Which exams are supported?", a: "JEE, NEET, SSC, Banking, Railway, other Government competitive exams, and now GATE and CAT as well. More exams will continue to be added over time." },
  { q: "Who is sarkarijobai for?", a: "Serious aspirants — self-studiers who want a system, coaching students who want personalisation, repeaters who need to know exactly what went wrong, and government-exam aspirants who need consistency and accountability." },
  { q: "Do I need to stop using my current coaching?", a: "No. sarkarijobai is designed to work alongside your existing classes, books, YouTube and mock tests. It makes your existing resources more effective — it does not replace them." },
  { q: "How does the AI create my study plan?", a: "It combines a diagnostic of your current preparation, your performance data, your weak concepts, your available daily time and your target — then prioritises the highest-impact work for each day." },
  { q: "How much time do I need to study each day?", a: "You decide. During setup you choose the daily study time you can realistically commit to, and your plan is built around exactly that. Your commitment also matters for the money-back guarantee (see below), so choose an amount you can genuinely follow." },
  { q: "How does the money-back guarantee work?", a: "The guarantee is tied to your own commitment. When you begin, you choose your daily study time — and the money-back guarantee applies only if you actually complete the study time you selected at the start (along with the other required activities such as mock tests and milestones) and still don't achieve the defined qualifying outcome. In short: finish the study hours you committed to, and if the result still doesn't come, you may claim a refund. Eligibility conditions apply — see the full guarantee terms." },
  { q: "What happens if I don't complete my chosen study time?", a: "Then you won't be eligible for the money-back guarantee. The guarantee only protects students who actually put in the study time they committed to at the start (plus the required mocks and milestones). If you skip the hours you chose, refund eligibility does not apply — but you can still use every feature of the platform." },
  { q: "Does sarkarijobai guarantee selection?", a: "No. sarkarijobai does not guarantee admission, rank, government employment or selection. Any refund guarantee applies only under the specific published eligibility and qualifying-outcome terms — and only if you completed your committed study time." },
  { q: "Can I upload my mock tests for analysis?", a: "Yes. Upload a screenshot or PDF of your mock report and the AI reads your score, percentile and weak topics automatically — then folds those insights into your daily plan." },
  { q: "Will it still help in the last few months before my exam?", a: "Yes. When time is short, deciding what to study matters most. sarkarijobai focuses your remaining days on the highest-impact topics and the mistakes costing you the most marks." },
  { q: "Is there a free trial?", a: "There is no free trial today. Instead, we reduce your risk with the money-back guarantee — follow the program and complete your chosen study time, and if the defined qualifying outcome still isn't met, you may claim a refund under the published terms." },
  { q: "What does it cost and can I cancel?", a: "Two plans: ₹1,999/month or ₹19,999/year (which works out to about ₹1,667/month and saves ₹3,989 versus paying monthly). Payments are processed securely via Razorpay (UPI, cards, netbanking, wallets). You can cancel anytime — cancellation stops future billing, and access continues for the period you've already paid for." },
  { q: "Can I use sarkarijobai with PW / Allen / YouTube / books?", a: "Yes. sarkarijobai is built to complement any resource you already use. Mentioning these does not imply any partnership or endorsement." },
  { q: "Can parents track progress?", a: "Yes. A Parent View in the dashboard gives a simple, honest summary of your child's consistency (active study days, coach interactions, mocks tracked), current focus areas and score trajectory — without inflating any numbers." },
  { q: "Can the AI make mistakes?", a: "Yes. AI outputs are monitored and verified where appropriate, but they can still be imperfect. Always rely on official exam sources for authoritative information." },
  { q: "Is my data safe?", a: "We follow reasonable privacy practices and use your data only to personalise your preparation. See our Privacy Policy for details on what we collect and how it is used." },
];
